import { WELCOME, type PortalConfig } from '@sonder/shared'

export function firstNames(names: string[]) {
  const f = names.map((n) => n.split(' ')[0]).filter(Boolean)
  if (f.length === 0) return ''
  if (f.length === 1) return f[0]!
  return `${f.slice(0, -1).join(', ')} and ${f[f.length - 1]}`
}

export function brandList(names: string[]) {
  if (names.length <= 1) return names[0] ?? 'your brand'
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`
}

export type WelcomeCopy = { eyebrow: string; headline: string; subhead: string; lead: string; duration: string; scopeNotes: string; headlineIsDefault: boolean; leadIsDefault: boolean }

/**
 * Everything the welcome screen says, resolved from the portal config plus live data. The client's
 * page and the staff Setup preview both call this, so the preview is exactly what the client sees.
 */
export function welcomeCopy(input: { clientName: string; config: Pick<PortalConfig, 'copy' | 'scopeNotes'>; memberNames: string[]; brandNames: string[] }): WelcomeCopy {
  const names = firstNames(input.memberNames)
  const headline = input.config.copy?.welcomeHeadline?.trim()
  const lead = input.config.copy?.welcomeBody?.trim()
  return {
    eyebrow: WELCOME.eyebrow,
    headline: headline || WELCOME.headline(input.clientName),
    subhead: WELCOME.subhead,
    lead: lead || WELCOME.lead(names || 'Hello', brandList(input.brandNames)),
    duration: WELCOME.duration,
    scopeNotes: input.config.scopeNotes ?? '',
    headlineIsDefault: !headline,
    leadIsDefault: !lead,
  }
}
